import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { Observable } from 'rxjs/observable';
import { Lead } from '../model/lead';
import { LeadserviceService } from '../service/leadservice.service';


@Component({
  selector: 'app-form-contact',
  templateUrl: './form-contact.component.html',
  styleUrls: ['./form-contact.component.scss']
})
export class FormContactComponent implements OnInit {
  @Input() Location: string;

  endview = 0;
  lead: Lead;
  validatingFormContatto: FormGroup;
  constructor( private service: LeadserviceService, private fb: FormBuilder) { }




    ngOnInit() {

      this.lead = new Lead();
      this.validatingFormContatto = this.fb.group({

        'nome': new FormControl(this.lead.nome, [Validators.required]),
        'cognome': new FormControl(this.lead.cognome, [Validators.required]),
        'email': new FormControl(this.lead.email, [Validators.email,Validators.pattern('^$|^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$')]),
        'cap': new FormControl(this.lead.cap, [Validators.required]),
        'telefono': new FormControl(this.lead.telefono, [Validators.required]),
        'privacy': new FormControl(this.lead.privacy1, [Validators.requiredTrue]),
        'termini': new FormControl(this.lead.privacy2, [Validators.requiredTrue]),
        'note': new FormControl(this.lead.Note, []),

      });



  }

  send() {

    if (this.validatingFormContatto.valid) {
      if (this.Location == null) { this.Location = ""; }
      console.log(this.diagnostic);
      this.endview = 1;

        this.service.sendleads(this.lead, this.Location).subscribe(
          o => {

            this.endview = 2;
            console.log(this.endview);
            console.log(o);
            this.lead = new Lead();



          },error => {this.endview=2; console.log("errore api") }
        )

    }
    else {

      this.validatingFormContatto.controls['nome'].markAsTouched();
      this.validatingFormContatto.controls['cognome'].markAsTouched();
      this.validatingFormContatto.controls['email'].markAsTouched();
      this.validatingFormContatto.controls['cap'].markAsTouched();
      this.validatingFormContatto.controls['telefono'].markAsTouched();
      this.validatingFormContatto.controls['termini'].markAsTouched();
      this.validatingFormContatto.controls['privacy'].markAsTouched();
    }


  }

  get diagnostic() { return JSON.stringify(this.lead); }

}



// WEBPACK FOOTER //
// ./src/app/form-contact/form-contact.component.ts